module.exports = __webpack_public_path__ + "assets/0be8c638832595f07240f8342c4a2221.png";